import { VideoCarousel } from "Explore/Components";
import styles from "./VideoPresentations.module.scss";
const VideoPresentations = ({ videos }) => {
  return (
    <div className={styles["video-presentations"]}>
      {videos?.length > 0 && (
        <div className={styles["lectures"]}>
          <p className={styles["section-title"]}>Video Presentations</p>
          <VideoCarousel videoUrls={videos} />
        </div>
      )}
    </div>
  );
};

export default VideoPresentations;
